export default function Button({ className = '', disabled, children, ...props }) {
    return (
        <button
            {...props}
            className={
                `flex items-center gap-2 text-white bg-main-color hover:bg-custom-orange-900 h-11 transition-colors font-semibold rounded-[4px] text-sm px-5 py-2 focus:outline-none ` + className
            }
            disabled={disabled}
        >
            {children}
        </button>
    );
}
